import React from "react";

import {
  Wrapper,
  CardBody,
  Bold,
  Copy,
  Row,
  Icon
} from "app/NativeComponents/common";

const IGNORE_VALUE = "IGNORE";

const Samples = props => {
  if (
    props.header_item.header_mapped_value !== IGNORE_VALUE &&
    props.upload_list_info.sample_rows
  ) {
    return (
      <CardBody
        style={{
          overflow: "hidden"
        }}
      >
        <Copy>
          <Bold>Samples from your list:</Bold>
        </Copy>
        {props.upload_list_info.sample_rows.map((row, i) => {
          return (
            <Row style={{ height: "18px" }}>
              <Icon
                size={8}
                icon="fiber-manual-record"
                style={{
                  marginRight: 5
                }}
              />
              <Copy
                key={i}
                style={{
                  whiteSpace: "nowrap"
                }}
              >
                {row[props.header_item.header_index]
                  ? row[props.header_item.header_index]
                  : ""}
              </Copy>
            </Row>
          );
        })}
      </CardBody>
    );
  }

  return <Wrapper style={{ flex: 1 }} />;
};

export default React.memo(Samples);
